import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import LoadingSpinner from './LoadingSpinner';

const TechniciansByService = () => {
    const { serviceName } = useParams();
    const [technicians, setTechnicians] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchPincode, setSearchPincode] = useState('');

    const fetchTechnicians = async (pincode = '') => {
        setLoading(true);
        try {
            const url = pincode 
                ? `https://local-technician-finder-backend.onrender.com/api/technicians?serviceName=${serviceName}&pincode=${pincode}` 
                : `https://local-technician-finder-backend.onrender.com/api/technicians?serviceName=${serviceName}`;
            const res = await axios.get(url);
            setTechnicians(res.data);
        } catch (err) {
            console.error(err);
            setError(`Failed to fetch technicians for ${serviceName}.`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTechnicians(searchPincode);
    }, [serviceName, searchPincode]);

    const handlePincodeSearch = () => {
        fetchTechnicians(searchPincode);
    };

    if (loading) return <LoadingSpinner />;
    if (error) return <div>{error}</div>;

    return (
        <div className="container mt-4">
            <h1 className="mb-4 text-center">Technicians for {serviceName}</h1>
            <div className="mb-4 p-3 border rounded bg-light">
                <div className="form-group d-flex align-items-center">
                    <label htmlFor="pincodeSearch" className="form-label me-2 mb-0">Search by Pincode:</label>
                    <input 
                        type="text" 
                        id="pincodeSearch"
                        value={searchPincode} 
                        onChange={(e) => setSearchPincode(e.target.value)} 
                        placeholder="Enter Pincode"
                        className="form-control w-auto me-2"
                    />
                    <button onClick={handlePincodeSearch} className="btn btn-primary">Search</button>
                </div>
            </div>
            {technicians.length === 0 ? (
                <p className="text-center">No technicians found offering {serviceName}.</p>
            ) : (
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-2">
                    {technicians.map(tech => (
                        <div className="col" key={tech._id}>
                            <div className="card h-100 shadow-sm">
                                <div className="card-body d-flex flex-column p-2">
                                    <h5 className="card-title mb-1">
                                        <Link to={`/technicians/${tech.userId._id}`} className="text-decoration-none text-primary">
                                            {tech.firstName} {tech.lastName}
                                        </Link>
                                    </h5>
                                    <h6 className="card-subtitle mb-1 text-muted">Pincode: {tech.pincode}</h6>
                                    <p className="card-text flex-grow-1 mb-1">
                                        <strong>Services:</strong> {
                                            tech.servicesOffered && tech.servicesOffered.length > 0 
                                                ? tech.servicesOffered.map(s => s.name).join(', ') 
                                                : 'No services specified'
                                        }
                                    </p>
                                    <div className="mt-auto">
                                        <p className="card-text mb-1">
                                            Rating: <strong>{tech.averageRating.toFixed(1)}</strong> ({tech.totalReviews} reviews)
                                        </p>
                                        <Link to={`/technicians/${tech.userId._id}`} className="btn btn-sm btn-outline-primary">View Profile</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TechniciansByService;